import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import navigation from '../../../data/navigation.json';
import { TransferService } from '../../../services/datashare/transfer.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-header-one',
  templateUrl: './header-one.component.html',
  styleUrls: ['./header-one.component.css']
})
export class HeaderOneComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document, private transferService: TransferService, private router: Router) { }
  // Sticky Nav
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
    //set up the div "id=nav"
    if (document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100) {
      document.getElementById('can-sticky').classList.add('sticky-on');
    }
    else {
      document.getElementById('can-sticky').classList.remove('sticky-on');
    }
  }
  public navigation = navigation;
  // public path = '/Angus/'
  public path = '/'
  // Navigation
  navmethod: boolean = true;
  toggleNav() {
    this.navmethod = !this.navmethod;
  }

  login(){
    this.navmethod = !this.navmethod;
    this.transferService.clearData();
    this.transferService.setData({'blnAutoLogin': true});
    this.router.navigate(["/about"]);
  }
  // Mobile
  open: boolean = false;
  trigger(item: { open: boolean; }){
    item.open = !item.open;
  }
  // Add class on resize and onload window
  visible: boolean = false;
  breakpoint: number = 991;
  public innerWidth: any;
  detectHeader() {
    this.innerWidth = window.innerWidth;
    this.visible = this.innerWidth >= this.breakpoint;
  }

  ngOnInit(): void {
    this.detectHeader();
    let section = localStorage.getItem('section');
    switch(section) {
      case 'Home':
        this.goToHome()
        break;
      case 'Estandar':
        this.goToEstandar()
        break;
      case 'Certificarse':
        this.goToCertificarse()
        break;
      case 'Beneficios':
        this.goToBeneficios()
        break;
      case 'Noticias':
        this.goToNoticias()
        break;
      case 'Contacto':
        this.goToContacto()
        break;
    }
  }

  goToHome() {
    location.href = "#Home";
    if (window.location.pathname === this.path) {
      setTimeout(function(){
        location.href = "#Home";
       }, 500);
      localStorage.setItem('section', '');
    } else {
      window.location.href = this.path;
      localStorage.setItem('section', 'Home');
    }
  }

  goToEstandar() {
    location.href = "#Estandar";
    if (window.location.pathname === this.path) {
      setTimeout(function(){
        location.href = "#Estandar";
       }, 500);
      localStorage.setItem('section', '');
    } else {
      window.location.href = this.path;
      localStorage.setItem('section', 'Estandar');
    }
  }
  goToCertificarse() {
    location.href = "#Certificarse";
    if (window.location.pathname === this.path) {
      setTimeout(function(){
        location.href = "#Certificarse";
       }, 500);
      localStorage.setItem('section', '');
    } else {
      window.location.href = this.path;
      localStorage.setItem('section', 'Certificarse');
    }
  }
  goToBeneficios() {
    location.href = "#Beneficios";
    if (window.location.pathname === this.path) {
      setTimeout(function(){
        location.href = "#Beneficios";
       }, 500);
      localStorage.setItem('section', '');
    } else {
      window.location.href = this.path;
      localStorage.setItem('section', 'Beneficios');
    }
  }
  goToNoticias() {
    location.href = "#Noticias";
    if (window.location.pathname === this.path) {
      setTimeout(function(){
        location.href = "#Noticias";
       }, 500);
      localStorage.setItem('section', '');
    } else {
      window.location.href = this.path;
      localStorage.setItem('section', 'Noticias');
    }
  }
  goToContacto() {
    location.href = "#Contacto";
    if (window.location.pathname === this.path) {
      setTimeout(function(){
        location.href = "#Contacto";
       }, 500);
      localStorage.setItem('section', '');
    } else {
      window.location.href = this.path;
      localStorage.setItem('section', 'Contacto');
    }
  }

}
